var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap -m-1"},_vm._l((_vm.categories),function(category,index){return _c('div',{key:index,staticClass:"m-1"},[(category)?_c('div',{staticClass:"label"},[_vm._v("# "+_vm._s(category.name))]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }